import { BearingEnvelope } from '@paragon/contract-library';
import { Point2D, Polygon2D } from '@paragon/geometry-library';
import { calculateBearingEnvelopeShape } from '@paragon/layout';
import { notNullish } from '@paragon/utilities';

import { RootState } from '..';

export const getDimensionedAreaForLayout = (state: RootState) =>
  getDimensionedAreaForBearingEnvelopes(Object.values(state.layout.bearingEnvelopes));

export const getDimensionedAreaForBearingEnvelopes = (envelopes: BearingEnvelope[]) => {
  const vertices = envelopes
    .map(calculateBearingEnvelopeShape)
    .flatMap((shape) => shape?.vertices)
    .filter(notNullish);

  const xs = vertices.map((v) => v.x);
  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const ys = vertices.map((v) => v.y);
  const minY = Math.min(...ys);
  const maxY = Math.max(...ys);

  const dimensionedArea = new Polygon2D([
    new Point2D(minX, minY),
    new Point2D(maxX, minY),
    new Point2D(maxX, maxY),
    new Point2D(minX, maxY),
  ]);

  return dimensionedArea;
};
